<template>
  <v-overlay
    :value="overlayOpen"
  >
    <v-progress-circular
      indeterminate
      size="64"
    />
  </v-overlay>
</template>

<script>
export default {
  name: 'OnLoadingOverlay',
  props: {
    overlayOpen: {
      type: Boolean,
      default: false
    }
  }

}
</script>

<style scoped>

</style>
